import { initGlobalState } from 'qiankun'

const initialState = {}
const actions = initGlobalState(initialState)

export default actions
